import * as React from "react";
import { format, parseISO } from 'date-fns'
import {makeStyles} from "@material-ui/styles";
import mock from "../mock.json";
import Correcoes from "./Correcoes";
import Alarmes from "./Alarmes";
import Avancos from "./Avancos";
import PaginaA4 from "../../../../components/reports/paginaA4";

const useStyles = makeStyles(theme => ({

}));

const Pagina2 = (props) => {
    const classes = useStyles();

    const raspaReportData = props.raspaReportData? props.raspaReportData : mock;

    return (
        <PaginaA4
            titulo={'PRODUTIVIDADE RASPAROBO LUKATEC'}
            subtitulo={`PERIODO ${format(parseISO(raspaReportData.periodo.periodo.periodoIni),'dd/MM/yyyy')} A ${format(parseISO(raspaReportData.periodo.periodo.periodoFim),'dd/MM/yyyy')}`}
            areaCima={<React.Fragment>
                <Correcoes raspaReportData={raspaReportData}/>
                <Avancos raspaReportData={raspaReportData}/>
                <Alarmes raspaReportData={raspaReportData}/>
            </React.Fragment>}
            areaBaixo={<React.Fragment/>}
            rodape={``}
            pagina={2}
        />
    )
}


export default  Pagina2;